if (!window.Eurus.loadedScript.has('product-bundle.js')) {
window.Eurus.loadedScript.add('product-bundle.js');

const ECO_TAX_VARIANT_ID = 57383508771151;

requestAnimationFrame(() => {
  document.addEventListener("alpine:init", () => {
    Alpine.data('xProductBundle', (
      sectionId,
      minimumItems,
      shopCurrency,
      discountType,
      discountValue,
      applyDiscountOncePerOrder,
      // Grup A
      groupAMin,
      groupAMax,
      groupALabel,
      groupADiscountType,
      groupADiscountValue,
      // Grup B
      groupBEnabled,
      groupBProductId,
      groupBQuantity,
      groupBLabel,
      groupBDiscountType,
      groupBDiscountValue,
      // Grup C
      groupCEnabled,
      groupCProductId,
      groupCQuantity,
      groupCLabel,
      groupCDiscountType,
      groupCDiscountValue
    ) => ({
      products: "",
      productsBundle: [],
      loading: false,
      addToCartButton: "",
      totalPrice: 0,
      errorMessage: false,
      showBundleContent: false,
      totalDiscount: 0,
      amountPrice: 0,
      progressMessage: '',
      hasDiscount: false,

      initBundle(el) {
        this.addToCartButton = el.querySelector(".button-atc");
        this.handleProductsBundle();
      },

      handleProductsBundle() {
        this.$watch('productsBundle', () => {
          document.dispatchEvent(new CustomEvent(`eurus:product-bundle:productsList-changed-${sectionId}`, {
            detail: { productsBundle: this.productsBundle }
          }));
        });
      },

      _getSelectedValueId(el) {
        return el.querySelector("select option[selected][value], fieldset input:checked")?.dataset.optionValueId;
      },
      _getCurrentVariantEl(el) {
        return el.querySelector(`script[type="application/json"][data-option-value-id='${this._getSelectedValueId(el)}']`);
      },
      _getCurrentVariable(el) {
        return JSON.parse(this._getCurrentVariantEl(el)?.textContent);
      },

      // Determina grupa unui produs
      _getGroup(productId) {
        const pid = String(productId);
        if (groupBEnabled && String(groupBProductId) === pid) return 'B';
        if (groupCEnabled && String(groupCProductId) === pid) return 'C';
        return 'A';
      },

      addToBundle(el, productId, productUrl, hasVariant, name_edt) {
        let productsBundle = JSON.parse(JSON.stringify(this.productsBundle));
        const productName = el.closest(".x-product-bundle-data").querySelector(".product-name").textContent;
        const currentVariant = hasVariant
          ? this._getCurrentVariable(el.closest(".x-product-bundle-data"))
          : JSON.parse(el.closest(".x-product-bundle-data").querySelector(`script[type='application/json'][data-id='${productId}']`).textContent);
        const price = !hasVariant && JSON.parse(el.closest(".x-product-bundle-data").querySelector(".current-price")?.textContent);
        const featured_image = currentVariant.featured_image
          ? currentVariant.featured_image.src
          : el.closest(".x-product-bundle-data").querySelector(".featured-image").textContent;

        const edtElement = el.closest(".x-product-bundle-data").querySelector(`.hidden.cart-edt-properties-${productId}`);
        let shippingMessage = '';
        if (edtElement) {
          shippingMessage = edtElement.value.replace("time_to_cut_off", Alpine.store('xEstimateDelivery').noti);
        }
        const preorderElement = el.closest(".x-product-bundle-data").querySelector('.hidden.preorder-edt-properties');
        let preorderMessage = '';
        if (preorderElement) preorderMessage = preorderElement.value;

        const properties = {
          ...(name_edt && shippingMessage && { [name_edt]: shippingMessage }),
          ...(preorderMessage && { Preorder: preorderMessage }),
        };

        let newItem = hasVariant
          ? { ...currentVariant, title: currentVariant.title.replaceAll("\\",""), product_id: productId, product_name: productName, productUrl: `${productUrl}?variant=${currentVariant.id}`, featured_image, quantity: 1, properties }
          : { id: currentVariant.id, product_id: productId, product_name: productName, productUrl, featured_image, quantity: 1, price, properties };

        let newProductsBundle = [...productsBundle, newItem];
        this.productsBundle = newProductsBundle;
        this.errorMessage = false;
        this.updateBundleContent(newProductsBundle);

        let bundleContentContainer = document.getElementById(`bundle-content-container-${sectionId}`);
        requestAnimationFrame(() => {
          let splide = bundleContentContainer.splide;
          if (splide) {
            splide.refresh();
            splide.go(splide.Components.Controller.getEnd());
          }
        });
      },

      async handleAddToCart(el) {
        this.loading = true;
        await Alpine.store('xCartHelper').waitForEstimateUpdate();
        window.updatingEstimate = true;

        setTimeout(() => {
          let items = JSON.parse(JSON.stringify(this.productsBundle));

          items = items.reduce((data, product) => {
            data[product.id] ? data[product.id].quantity += product.quantity : data[product.id] = product;
            return data;
          }, {});

          let itemsArray = Object.values(items);
          itemsArray.push({ id: ECO_TAX_VARIANT_ID, quantity: 1, properties: { '_eco': true } });

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ "items": itemsArray, "sections": Alpine.store('xCartHelper').getSectionsToRender().map(s => s.id) })
          })
          .then(r => r.json())
          .then(response => {
            document.dispatchEvent(new CustomEvent(`eurus:product-bundle:products-changed-${sectionId}`, {
              detail: { productsBundle: itemsArray, el: el.closest(".product-bundler-wrapper") }
            }));

            if (response.status == '422') {
              const error_message = el.closest('.bundler-sticky').querySelector('.cart-warning');
              this.errorMessage = true;
              if (error_message) error_message.textContent = response.description;
              return;
            }

            this.errorMessage = false;
            Alpine.store('xCartHelper').getSectionsToRender().forEach(section => {
              section.selector.split(',').forEach(selector => {
                const sectionElement = document.querySelector(selector);
                if (sectionElement && response.sections[section.id]) {
                  sectionElement.innerHTML = getSectionInnerHTML(response.sections[section.id], selector);
                }
              });
            });

            if (Alpine.store('xQuickView') && Alpine.store('xQuickView').show) Alpine.store('xQuickView').show = false;
            Alpine.store('xPopup').close();
            if (Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable) {
              Alpine.store('xCartNoti').setItem(response);
            } else {
              Alpine.store('xMiniCart').openCart();
              document.dispatchEvent(new CustomEvent("eurus:cart:redirect"));
            }
            Alpine.store('xCartHelper').currentItemCount = parseInt(document.querySelector('#cart-icon-bubble span').innerHTML);
            document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
          })
          .catch(error => console.error('Error:', error))
          .finally(() => {
            Alpine.store('xCartHelper').updateEstimateShippingFull();
            this.loading = false;
            this.productsBundle = [];
            this.totalPrice = 0;
            this.addToCartButton.setAttribute('disabled', 'disabled');
          });
        }, 0);
      },

      // Calculeaza discount pentru un grup de produse
      _calcGroupDiscount(groupItems, gDiscountType, gDiscountValue) {
        if (!gDiscountValue || isNaN(Number(gDiscountValue))) return 0;
        const groupTotal = groupItems.reduce((sum, item) => sum + (item.price * (item.quantity || 1)), 0);
        const disc = Number(gDiscountValue);
        if (gDiscountType === 'percentage' && disc > 0 && disc < 100) {
          return Math.round(groupTotal * disc / 100);
        }
        if (gDiscountType === 'amount' && disc > 0) {
          const discPerItem = parseFloat(gDiscountValue) * Shopify.currency.rate * 100;
          return discPerItem * groupItems.reduce((sum, i) => sum + (i.quantity || 1), 0);
        }
        return 0;
      },

      updateBundleContent(productsBundle) {
        // Filtreaza eco tax
        const items = productsBundle.filter(item => item.id !== ECO_TAX_VARIANT_ID);

        // Imparte pe grupe
        const groupAItems = items.filter(i => this._getGroup(i.product_id) === 'A');
        const groupBItems = items.filter(i => this._getGroup(i.product_id) === 'B');
        const groupCItems = items.filter(i => this._getGroup(i.product_id) === 'C');

        const countA = groupAItems.length;
        const countB = groupBItems.length;
        const countC = groupCItems.length;

        // Verifica daca grupele A/B/C au discounturi setate
        const hasGroupADiscount = groupADiscountValue && !isNaN(Number(groupADiscountValue)) && Number(groupADiscountValue) > 0;
        const hasGroupBDiscount = groupBEnabled && groupBDiscountValue && !isNaN(Number(groupBDiscountValue)) && Number(groupBDiscountValue) > 0;
        const hasGroupCDiscount = groupCEnabled && groupCDiscountValue && !isNaN(Number(groupCDiscountValue)) && Number(groupCDiscountValue) > 0;
        const useGroupDiscounts = hasGroupADiscount || hasGroupBDiscount || hasGroupCDiscount;

        // useGroups = true daca B sau C sunt active (pentru validare)
        const useGroups = groupBEnabled || groupCEnabled;

        // Validare
        let bundleValid = false;
        let messages = [];

        if (useGroups) {
          // Validare cu grupe A/B/C
          const aMin = groupAMin || minimumItems;
          const aMax = groupAMax || 999;
          const aValid = countA >= aMin && countA <= aMax;

          const bValid = !groupBEnabled || countB >= groupBQuantity;
          const cValid = !groupCEnabled || countC >= groupCQuantity;

          bundleValid = aValid && bValid && cValid;

          // Mesaje progress
          if (!aValid) {
            const need = aMin - countA;
            if (need > 0) messages.push(`Mai adaugă ${need} ${groupALabel || 'produs'} din Grupa A`);
          }
          if (groupBEnabled && !bValid) {
            const need = groupBQuantity - countB;
            messages.push(`Mai adaugă ${need} ${groupBLabel || 'produs'} din Grupa B`);
          }
          if (groupCEnabled && !cValid) {
            const need = groupCQuantity - countC;
            messages.push(`Mai adaugă ${need} ${groupCLabel || 'produs'} din Grupa C`);
          }
        } else {
          // Validare simpla - doar minimumItems (sau groupAMin daca e setat)
          const aMin = groupAMin || minimumItems;
          bundleValid = items.length >= aMin;
          if (!bundleValid) {
            const need = aMin - items.length;
            messages.push(`Mai adaugă ${need} ${groupALabel || 'produs'}${need > 1 ? 'e' : ''}`);
          }
        }

        this.progressMessage = messages.join(' · ');

        // Totalul se afiseaza mereu, indiferent de validare
        const totalForDisplay = items.reduce((sum, i) => sum + (i.price * (i.quantity || 1)), 0);
        this.totalPrice = this.formatMoney(totalForDisplay, shopCurrency);

        if (bundleValid) {
          this.addToCartButton.removeAttribute('disabled');

          // Calculeaza total si discount
          const totalOriginal = items.reduce((sum, i) => sum + (i.price * (i.quantity || 1)), 0);
          let totalSaved = 0;

          if (useGroupDiscounts) {
            // Discount per grupa - se aplica intotdeauna daca e setat
            if (hasGroupADiscount && groupAItems.length > 0) {
              totalSaved += this._calcGroupDiscount(groupAItems, groupADiscountType, groupADiscountValue);
            }
            if (hasGroupBDiscount && groupBItems.length > 0) {
              totalSaved += this._calcGroupDiscount(groupBItems, groupBDiscountType, groupBDiscountValue);
            }
            if (hasGroupCDiscount && groupCItems.length > 0) {
              totalSaved += this._calcGroupDiscount(groupCItems, groupCDiscountType, groupCDiscountValue);
            }
          }

          if (totalSaved > 0) {
            const afterDiscount = totalOriginal - totalSaved;
            this.totalDiscount = this.formatMoney(afterDiscount, shopCurrency);
            this.amountPrice = this.formatMoney(totalSaved, shopCurrency);
            this.hasDiscount = true;
          } else {
            // Fara discount - totalDiscount=0 ca sa apara totalPrice (nu totalDiscount)
            this.totalDiscount = 0;
            this.amountPrice = 0;
            this.hasDiscount = false;
          }

        } else {
          this.totalDiscount = 0;
          this.amountPrice = 0;
          this.hasDiscount = false;
          this.addToCartButton.setAttribute('disabled', 'disabled');
        }

      },

      removeBundle(el, indexItem) {
        let item = this.productsBundle[indexItem];
        let newProductsBundle = this.productsBundle.filter((_, index) => index !== indexItem);
        this.productsBundle = newProductsBundle;
        this.updateBundleContent(newProductsBundle);

        let bundleContentContainer = document.getElementById(`bundle-content-container-${sectionId}`);
        requestAnimationFrame(() => {
          let splide = bundleContentContainer.splide;
          if (splide) {
            splide.refresh();
            splide.go(splide.Components.Controller.getEnd());
          }
        });

        document.dispatchEvent(new CustomEvent(`eurus:product-bundle:remove-item-${sectionId}`, {
          detail: { item, el }
        }));
      },

      formatWithDelimiters(number, precision, thousands, decimal) {
        precision = this.defaultOption(precision, 2);
        thousands = this.defaultOption(thousands, ',');
        decimal = this.defaultOption(decimal, '.');
        if (isNaN(number) || number == null) return 0;
        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents = parts[1] ? (decimal + parts[1]) : '';
        return dollars + cents;
      },

      defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
      },

      formatMoney(amount, formatString) {
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var value;
        switch (formatString.match(placeholderRegex)[1]) {
          case 'amount': value = this.formatWithDelimiters(amount, 2); break;
          case 'amount_no_decimals': value = this.formatWithDelimiters(amount, 0); break;
          case 'amount_with_comma_separator': value = this.formatWithDelimiters(amount, 2, '.', ','); break;
          case 'amount_no_decimals_with_comma_separator': value = this.formatWithDelimiters(amount, 0, '.', ','); break;
        }
        return formatString.replace(placeholderRegex, value);
      },

      displayDiscountValueLabel() {
        let discount = 0;
        if (!Number.isNaN(discountValue)) {
          discount = Number(discountValue);
          if (discount > 0) discount = parseFloat(discountValue) * Shopify.currency.rate * 100;
          return this.formatMoney(discount, shopCurrency);
        }
      }
    }));

    Alpine.data('xProductItemBundle', (
      sectionId,
      addToBundle,
      unavailableText,
      soldoutText,
      handleSectionId,
      productUrl,
      productId,
      hasVariant,
      productOnlyAddedOnce
    ) => ({
      dataVariant: [],
      currentVariant: '',
      isSelect: false,
      productId: productId,
      productUrl: productUrl,
      initEvent() {
        if (hasVariant) {
          document.addEventListener(`eurus:product-card-variant-select:updated:${sectionId}`, (e) => {
            this.currentVariant = e.detail.currentVariant;
            this.renderAddToBundleButton();
            this.checkVariantSelected();
            if (this.currentVariant && this.currentVariant.id) {
              this.productUrl = productUrl + `/?variant=${this.currentVariant.id}`;
            }
          });
        }

        document.addEventListener(`eurus:product-bundle:products-changed-${handleSectionId}`, (e) => {
          e.detail.productsBundle.map(item => {
            if (hasVariant && item.product_id == this.productId && this.currentVariant.available) {
              let buttonATC = document.querySelector('#x-atc-button-' + sectionId);
              if (buttonATC) buttonATC.removeAttribute('disabled');
            } else if (item.product_id == this.productId) {
              let buttonATC = document.querySelector('#x-atc-button-' + sectionId);
              if (buttonATC) buttonATC.removeAttribute('disabled');
            }
          });
          if (productOnlyAddedOnce) this.setUnSelectVariant();
        });

        document.addEventListener(`eurus:product-bundle:remove-item-${handleSectionId}`, (e) => {
          if (this.isSelect && e.detail.item.product_id == this.productId && hasVariant) {
            if (this.currentVariant && this.currentVariant.available) {
              let buttonATC = document.querySelector('#x-atc-button-' + sectionId);
              if (buttonATC) buttonATC.removeAttribute('disabled');
            }
            this.setUnSelectVariant(e.detail.item);
          } else if (e.detail.item.product_id == this.productId) {
            let buttonATC = document.querySelector('#x-atc-button-' + sectionId);
            if (buttonATC) buttonATC.removeAttribute('disabled');
            if (productOnlyAddedOnce) {
              const cardProducts = document.querySelector('#bundle-product-' + e.detail.item.product_id);
              cardProducts?.classList.remove("cursor-pointer", "pointer-events-none", "opacity-70");
            }
          }
        });
      },

      setVariantSelected(el) {
        if (this.currentVariant && this.dataVariant.findIndex(item => (item.id == this.currentVariant.id && item.disable)) != -1) {
          let buttonATB = el.closest('.bundle-product').querySelector('.x-atb-button');
          buttonATB.setAttribute('disabled', 'disabled');
        }
      },

      setDisableSelectProduct(el) {
        if (productOnlyAddedOnce) {
          let newVariants = JSON.parse(JSON.stringify(this.dataVariant)).map(item => (item.id == this.currentVariant.id) ? { id: item.id, disable: true } : { id: item.id, disable: item.disable });
          this.dataVariant = newVariants;
          let buttonATB = el.closest('.bundle-product').querySelector('.x-atb-button');
          buttonATB.setAttribute('disabled', 'disabled');
        }
      },

      setUnSelectVariant(product) {
        let newVariants = product
          ? JSON.parse(JSON.stringify(this.dataVariant)).map(item => (item.id == product.id) ? { id: item.id, disable: false } : { id: item.id, disable: item.disable })
          : JSON.parse(JSON.stringify(this.dataVariant)).map(item => ({ id: item.id, disable: false }));
        this.dataVariant = newVariants;
      },

      renderAddToBundleButton() {
        const buttonATB = document.getElementById('x-atc-button-' + sectionId);
        if (!buttonATB) return;
        const addButtonText = buttonATB.querySelector('.x-atc-text');
        if (addButtonText) {
          if (this.currentVariant) {
            if (this.currentVariant.available) {
              buttonATB.removeAttribute('disabled');
              addButtonText.textContent = addToBundle;
            } else {
              addButtonText.textContent = soldoutText;
            }
          } else {
            addButtonText.textContent = unavailableText;
          }
        }
      },

      checkVariantSelected() {
        const fieldset = [...document.querySelectorAll(`#variant-update-${sectionId} fieldset`)];
        if (fieldset.findIndex(item => !item.querySelector("input:checked")) == "-1") {
          this.isSelect = true;
        }
      }
    }));

    Alpine.data('xProductList', (sectionId, handleSectionId) => ({
      productsList: [],
      init() {
        document.addEventListener(`eurus:product-bundle:productsList-changed-${handleSectionId}`, (e) => {
          this.productsList = e.detail.productsBundle;
        });
        document.addEventListener(`eurus:product-card-variant-select:updated:${sectionId}`, () => {
          this.renderAddButton();
        });
      },
      renderAddButton() {
        const currentVariant = JSON.parse(document.getElementById('current-variant-' + sectionId).textContent);
        let variantId = typeof currentVariant === 'object' ? currentVariant?.id : currentVariant;
        const itemVariant = this.productsList.find(({ id }) => id === variantId);
        const buttonATB = document.getElementById('x-atc-button-' + sectionId);
        if (itemVariant && buttonATB) {
          setTimeout(() => { buttonATB.setAttribute('disabled', 'disabled'); }, 100);
        }
      }
    }));
  });
});
}
